import { render } from "./GridItem.vue?vue&type=template&id=0793f454&scoped=true"
import script from "./GridItem.vue?vue&type=script&setup=true&lang=js"
export * from "./GridItem.vue?vue&type=script&setup=true&lang=js"

import "./GridItem.vue?vue&type=style&index=0&id=0793f454&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0793f454"],['__file',"resources/js/modules/notification/components/GridItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0793f454"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0793f454', __exports__)) {
    api.reload('0793f454', __exports__)
  }
  
  module.hot.accept("./GridItem.vue?vue&type=template&id=0793f454&scoped=true", () => {
    api.rerender('0793f454', render)
  })

}


export default __exports__